/* eslint-disable linebreak-style */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import './orderheader.css'
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  Tooltip,
  colors
} from '@material-ui/core';
import { dataFormatRO } from '../../../../utils/functiiComune';
import {setUpdatedOrder} from '../../../../redux/order/order.actions'
import {selectOrderCurrentProduct, selectOrderCurrentOrder,selectOrderUpdatedOrder  } from '../../../../redux/order/order.selectors'
import {selectCurrentUser } from '../../../../redux/user/user.selectors'
import {selectDeliveryAddresses } from '../../../../redux/user/user.selectors'
import {selectLookupFirmeComisionar} from '../../../../redux/lookup/lookup.selectors'
import { t, orderStatusLabel } from '../../../../i18n';
import { getLocalizedText } from '../../../../utils/lookupLocale';


const useStyles = makeStyles(() => ({
  header:{
    background:colors.blueGrey[700],
    textAlign:'center',
    color:'grey'
  },
  menu: {
    width: 200,
  },
  centerGrid:{
    alignContent: 'center'
  }
}));

const OrderHeader = props => {
  const { className,currentProduct, currentUser, deliveryAddresses, firmeComisionar, setUpdatedOrder, updatedOrder} = props;
  const classes = useStyles();
  const isComisionar = currentUser?.idFirma?.cfg1 === 'DA';
  const isExpozorOrder = currentProduct?.cod === 'ex';
  const hasRepere = Array.isArray(updatedOrder?.comandarepers) && updatedOrder.comandarepers.length > 0;
  const lockClientFinalComisionar = isComisionar && (hasRepere || updatedOrder?.clientFinalLocked === true);
  const getIdFirmaValue = (idFirmaField)=>{
    if (idFirmaField && typeof idFirmaField === 'object') {
      return Number(idFirmaField.id || 0)
    }
    return Number(idFirmaField || 0)
  }
  const getDiscountCheieProdus = (codProdus)=>{
    switch(codProdus){
    case 'jv':
      return 'discountJV';
    case 'ro':
      return 'discountRO';
    case 're':
      return 'discountRE';
    case 'ug':
      return 'discountUG';
    case 'pi':
      return 'discountPI';
    case 'jo':
      return 'discountJO';
    default:
      return null;
    }
  }
  const getDiscountPeProdus = (firma, codProdus)=>{
    const cheie = getDiscountCheieProdus(codProdus)
    if(!cheie || !firma){
      return 0
    }
    return Number(firma[cheie] || 0)
  }
  //----------------------------------------------------------------
  const [values, setValues] = useState({
    id: updatedOrder.id,
    dataComanda: updatedOrder.dataComanda,
    clientClient:updatedOrder.clientClient,
    idFirmaClientFinal: getIdFirmaValue(updatedOrder.idFirma),
    observatii:updatedOrder.observatii,
    adresaLivrare:updatedOrder.adresaLivrare,
    discount:updatedOrder.discount,
    subTip:updatedOrder.subTip
  });
  const idClientFinalSelectat = Number(values.idFirmaClientFinal || getIdFirmaValue(updatedOrder?.idFirma) || 0);
  const clientFinalSelectat = (firmeComisionar || []).find(firma=>Number(firma.id) === idClientFinalSelectat) || null;
  const discountClientFinalSelectat = getDiscountPeProdus(clientFinalSelectat, currentProduct?.cod);

  useEffect(()=>{
    setValues((prev)=>({
      ...prev,
      id: updatedOrder.id,
      dataComanda: updatedOrder.dataComanda,
      clientClient: updatedOrder.clientClient,
      idFirmaClientFinal: getIdFirmaValue(updatedOrder.idFirma),
      observatii: updatedOrder.observatii,
      adresaLivrare: updatedOrder.adresaLivrare,
      discount: updatedOrder.discount,
      subTip: updatedOrder.subTip
    }))
  },[updatedOrder])

  useEffect(()=>{
    const idFirmaSelectata = getIdFirmaValue(updatedOrder?.idFirma)
    if (!isComisionar || !idFirmaSelectata || idFirmaSelectata === Number(currentUser?.idFirma?.id || 0)) {
      return
    }
    if (!Array.isArray(firmeComisionar) || firmeComisionar.length === 0) {
      return
    }
    const firmaSelectata = firmeComisionar.find(firma=>Number(firma.id) === idFirmaSelectata)
    if (!firmaSelectata) {
      return
    }
    const nextClientClient = updatedOrder.clientClient || firmaSelectata.denumire
    const nextDiscountClientFinal = getDiscountPeProdus(firmaSelectata, currentProduct.cod)
    const nextDiscountComisionar = getDiscountPeProdus(currentUser?.idFirma, currentProduct.cod)
    if (
      updatedOrder.clientClient === nextClientClient &&
      Number(updatedOrder.discountClientFinal || 0) === nextDiscountClientFinal &&
      Number(updatedOrder.discountComisionar || 0) === nextDiscountComisionar
    ) {
      return
    }
    setUpdatedOrder({
      ...updatedOrder,
      clientClient: nextClientClient,
      discountClientFinal: nextDiscountClientFinal,
      discountComisionar: nextDiscountComisionar
    })
  }, [isComisionar, updatedOrder, currentUser, firmeComisionar, currentProduct, setUpdatedOrder])

  //----------------------------------------------------------------
  const handleChange = event => {
    const valoare = event.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    setValues({
      ...values,
      [event.target.name]: valoare
    });
    setUpdatedOrder({...updatedOrder,[event.target.name]: valoare})
  };
  //----------------------------------------------------------------
  const handleChangeClientComisionar = event => {
    const idClientFinal = Number(event.target.value || 0)
    const firmaSelectata = (firmeComisionar || []).find(firma=>firma.id===idClientFinal)
    const clientFinal = firmaSelectata ? firmaSelectata.denumire : ''
    const discountClientFinal = getDiscountPeProdus(firmaSelectata, currentProduct.cod)
    const discountComisionar = getDiscountPeProdus(currentUser?.idFirma, currentProduct.cod)

    setValues({
      ...values,
      idFirmaClientFinal: idClientFinal || '',
      clientClient: clientFinal
    })
    setUpdatedOrder({
      ...updatedOrder,
      idFirma: idClientFinal || 0,
      clientClient: clientFinal,
      discountClientFinal,
      discountComisionar
    })
  }
  //----------------------------------------------------------------
  const getHeaderSubTitle = ()=>{
    if (!values.id) {
      return t('orderHeader.pendingFirstSave');
    }
    const orderDate = dataFormatRO(values.dataComanda).substr(0,10);
    const updatedAt = dataFormatRO(updatedOrder.updated_at);
    if (values.stadiu === 'TRANSMISA') {
      return t('orderHeader.sentSubheader', {
        id: values.id,
        date: orderDate,
        updatedAt
      });
    }
    return t('orderHeader.updatedSubheader', {
      id: values.id,
      date: orderDate,
      updatedAt
    });
  };
  const getHeaderTitle = ()=>{
    return t('orderHeader.title', {
      product: getLocalizedText(currentProduct, 'title').toUpperCase(),
      status: orderStatusLabel(updatedOrder.stadiu)
    });
  };

  return (
    <Card
      className={className}
    >
      <form>
        <CardHeader
          className={classes.header}
          subheader={getHeaderSubTitle()}
          title={getHeaderTitle()}
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={1}
          >   
            {!isExpozorOrder && (
              <Grid
                item
                md={4}
                xs={12}
              >
                <Tooltip title={t('orderHeader.clientFinalTooltip')}>
                  {isComisionar ? (
                    <TextField
                      autoComplete='off'
                      disabled={(updatedOrder.stadiu && updatedOrder.stadiu==='TRANSMISA') || lockClientFinalComisionar ? true : false}
                      fullWidth
                      helperText={lockClientFinalComisionar ? t('orderHeader.clientFinalLocked') : ''}
                      InputLabelProps={{shrink:true}}
                      label={t('orderHeader.clientFinalLabel')}
                      margin="dense"
                      name="idFirmaClientFinal"
                      onChange={handleChangeClientComisionar}
                      required
                      select
                      SelectProps={{
                        native: true,
                        MenuProps: {
                          className: classes.menu,
                        }
                      }}
                      value={values.idFirmaClientFinal || ''}
                      variant="outlined"
                    >
                      <option key={0} value={''}>
                        {t('orderHeader.selectClientFinal')}
                      </option>
                      {(firmeComisionar || []).map(firma=>(
                        <option key={firma.id} value={firma.id}>
                          {firma.denumire}
                        </option>
                      ))}
                    </TextField>
                  ) : (
                    <TextField
                      autoComplete='off'
                      disabled={updatedOrder.stadiu && updatedOrder.stadiu==='TRANSMISA'?true:false}
                      fullWidth
                      InputLabelProps={{shrink:true}}
                      label={t('orderHeader.clientFinalLabel')}
                      margin="dense"
                      name="clientClient"
                      onChange={handleChange}
                      required
                      type="text"
                      value={values.clientClient || ''}
                      variant="outlined"
                    />
                  )}
                </Tooltip>
              </Grid>
            )}
            {!isExpozorOrder && isComisionar && clientFinalSelectat && (
              <Grid
                item
                md={8}
                xs={12}
              >
                <TextField
                  disabled
                  fullWidth
                  InputLabelProps={{shrink:true}}
                  label={t('orderHeader.clientFinalDetails')}
                  margin="dense"
                  value={t('orderHeader.clientFinalDetailsValue', {
                    ruta: clientFinalSelectat.ruta || '-',
                    oras: clientFinalSelectat.oras || '-',
                    adresa: clientFinalSelectat.adresa || '-',
                    email: clientFinalSelectat.email || '-',
                    telefon: clientFinalSelectat.telefon || '-',
                    product: String(currentProduct?.cod || '').toUpperCase(),
                    discount: discountClientFinalSelectat
                  })}
                  variant="outlined"
                />
              </Grid>
            )}
           
            {/* Doar pentru partea de masuratori ---------------------------------------------*/}
            {currentProduct.cod==="sv" &&
            <>
             <Grid
              item
              md={8}
              xs={12}
            >
              <Tooltip title={t('orderHeader.measurementsAddressTooltip')}>
                <TextField
                  autoComplete='off'
                  disabled={updatedOrder.stadiu && updatedOrder.stadiu==='TRANSMISA'?true:false}
                  fullWidth
                  InputLabelProps={{shrink:true}}
                  label={t('orderHeader.measurementsAddressLabel')}
                  margin="dense"
                  name="adresaLivrare"
                  onChange={handleChange}
                  type="text"
                  value={values.adresaLivrare || ''}
                  variant="outlined"
                >
                </TextField>
              </Tooltip>
            </Grid> 
            <Grid
              item
              md={4}
              xs={12}
            >
              <Tooltip title={t('orderHeader.measurementsTypeTooltip')}>
                <TextField
                  autoComplete='off'
                  disabled={updatedOrder.stadiu && updatedOrder.stadiu==='TRANSMISA'?true:false}
                  fullWidth
                  InputLabelProps={{shrink:true}}
                  label={t('orderHeader.productTypeLabel')}
                  margin="dense"
                  name="subTip"
                  onChange={handleChange}
                  required
                  select
                  SelectProps={{
                    native: true,
                    MenuProps: {
                      className: classes.menu,
                    }
                  }}
                  type="text"
                  value={values.subTip || ''}
                  variant="outlined"
                >
                  <option key="VERTICALE" value="JALUZELE VERTICALE">
                    JALUZELE VERTICALE
                  </option>
                  <option key="ROLETE" value="ROLETE PANZA">
                    ROLETE PANZA
                  </option>
                  <option key="RULOURI" value="RULOURI EXTERIOARE">
                    RULOURI EXTERIOARE
                  </option>
                  <option key="USI" value="USI GARAJ">
                    USI GARAJ
                  </option>
                  <option key="PLASE" value="PLASE INSECTE" >
                    PLASE INSECTE
                  </option>
                  <option key="ORIZONTALE" value="JALUZELE ORIZONTALE">
                    JALUZELE ORIZONTALE
                  </option>
                  <option key="" value="">
                  </option>

                </TextField>

              </Tooltip>
            </Grid>
            </> 
          }
          {/* -------------------- ---------------------------------------------*/}
            {isExpozorOrder && (
              <Grid
                item
                md={12}
                xs={12}
              >
                <Tooltip title={t('orderHeader.expoAddressTooltip')}>
                  <TextField
                    autoComplete='off'
                    disabled={updatedOrder.stadiu && updatedOrder.stadiu==='TRANSMISA'?true:false}
                    fullWidth
                    InputLabelProps={{shrink:true}}
                    label={t('orderHeader.expoAddressLabel')}
                    margin="dense"
                    name="adresaLivrare"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.adresaLivrare || ''}
                    variant="outlined"
                  />
                </Tooltip>
              </Grid>
            )}
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                autoComplete="off"
                disabled={updatedOrder.stadiu && updatedOrder.stadiu==='TRANSMISA'?true:false}
                fullWidth
                InputLabelProps={{shrink:true}}
                label={t('orderHeader.observationsLabel')}
                margin="dense"
                name="observatii"
                onChange={handleChange}
                type="text"
                value={values.observatii || ''}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
      </form>
    </Card>
  );
}

OrderHeader.propTypes = {
  className: PropTypes.string,
  currentProduct:PropTypes.object,
  deliveryAddresses:PropTypes.array,
  setUpdatedOrder:PropTypes.func,
  updatedOrder:PropTypes.object,
};


const mapStateToProps=state=>({
  currentProduct:selectOrderCurrentProduct(state),
  currentOrder:selectOrderCurrentOrder(state),
  currentUser:selectCurrentUser(state),
  deliveryAddresses:selectDeliveryAddresses(state),
  firmeComisionar:selectLookupFirmeComisionar(state),
  updatedOrder:selectOrderUpdatedOrder(state),
})

const mapDispatchToProps=dispatch=>({
  setUpdatedOrder:order=>dispatch(setUpdatedOrder(order)),
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(OrderHeader));
